export const getPackageVersionFromUnifyVersion = (unifyVersion: string): string =>
  unifyVersion.replace('.', '_').trim();
